import React, { useState, useEffect, forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import "assets/css/bookingNew.css";
import BookingStep3 from './Step3';
import { css } from "@emotion/react";
import { BookingCategoryOptions, BookingServiceOptions, BookingStaffOptions, BookingSelectedServicesData, BookingRemoveServicesData, PreviewStep, BookingResourceAnyStaffApi } from 'store/slices/bookingSlice';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import ApiStatus from 'component/ApiStatus';
import config from "../../../config";
import axios from "axios";
import PropTypes from 'prop-types';
import VoucherStep2 from '../../Booking/Form/buyVoucher/VoucherStep2';
import { Elements } from '@stripe/react-stripe-js';
import getStripeClient from "pages/getStripeClient";
import moment from 'moment';
import customToast from "component/Toastr";
import { MinutesToHours } from 'helpers/Functions';
import { MoonLoader } from 'react-spinners';
import { checkStaffAvailabilityApi } from 'store/slices/staffAvailabilitySlice';
import { LoadingOverlay } from 'utils/online-booking';
import authHeader from 'services/auth-header';
import MemebershipStep2 from '../membership-steps/Step2';
import SubscriptionStep2 from '../subscription/Step2';
import { getBookingSummaryApi } from 'store/slices/bookingSummarySlice';
// Add this loading overlay component at the top of your file


function BookingStep2(props) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isBookingStep = props.isBookingStep;
  const stripePromise = getStripeClient();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState({});
  const [activeSection, setActiveSection] = useState('services');
  const [expandedTreatments, setExpandedTreatments] = useState({});
  const [currentTreatments, setCurrentTreatments] = useState([]);
  const [selectedTreatments, setSelectedTreatments] = useState({});
  const [voucherFieldVisible, setVoucherFieldVisible] = useState(false);
  const [hide, setHide] = useState("main-content");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [allSelectedTreatments, setAllSelectedTreatments] = useState({});
  const [allSelectedStaff, setAllSelectedStaff] = useState({});
  const [activeTab, setActiveTab] = useState('services');
  const [datesData, setDatesData] = useState([
    // your dates array
  ]);
  const [loadingTreatments, setLoadingTreatments] = useState(false); // New loading state for treatments
  const isBookingApi = useSelector((state) => state.booking.isBookingApi);
  const bookingStepName = useSelector((state) => state.booking.isBookingStepName);
  const availableSlotSelectedStaff = useSelector((state) => state?.staffAvailability?.availabilityData);
  console.log('availableSlotSelectedStaff: ', availableSlotSelectedStaff);

  const categoryApiStatus = useSelector((state) => state.booking.isApiStatus);
  const isServiceOption = useSelector((state) => state.booking.isServiceOption);
  const isBookingSelectedServicesData = useSelector((state) => state.booking.isBookingSelectedServicesData);
  const objectDataServiceOnCategoryId = isServiceOption && isServiceOption.length > 0 ? isServiceOption : [];
  const [allServiceBycategory, setAllServiceByCategory] = useState(objectDataServiceOnCategoryId)
  const FilterSingleSelectedServiceData =
    isBookingSelectedServicesData &&
    isBookingSelectedServicesData.filter((item) => {
      if (item.id === isBookingSelectedServicesData.length) {
        return item;
      }
    });
  const singleSelectedServiceData = FilterSingleSelectedServiceData.length === 1 && FilterSingleSelectedServiceData[0];
  const categories = useSelector((state) => state.booking.isCategoryOption) || [];
  const [serviceApiLoading, setServiceApiLoading] = useState(false); // Add new loading state
  const [staffData, setStaffData] = useState({});
  const isBookingSelectedSubscriptionData = useSelector((state) => state.booking.isBookingSelectedSubscriptionData);



  // Add new state for staff loading
  const [staffApiLoading, setStaffApiLoading] = useState({});

  // Add new state for service summary
  const [serviceSummary, setServiceSummary] = useState({
    selectedItems: [],
    totals: {
      subtotal: 0,
      // discount: 0,
      // taxes: 0,
      total: 0
    }
  });
  // Add this new state at the top with other state declarations
  const [selectedCategories, setSelectedCategories] = useState(new Set());
  const [selectedCategoryData, setSelectedCategoryData] = useState({});
  const [categoryTreatments, setCategoryTreatments] = useState({});
  const [servicesLoading, setServicesLoading] = useState(true);
  // Add these loading states at the top with other state declarations
  const [categoryApiLoading, setCategoryApiLoading] = useState(false);
  const [treatmentApiLoading, setTreatmentApiLoading] = useState(false);

  const [loading, setLoading] = useState(false);
  const [activeloading, setActiveLoading] = useState(false);
  const availabletimeApiStatus = useSelector((state) => state.booking.isApiStatus);
  // Add this state near your other useState declarations
  const [availableTimeSlots, setAvailableTimeSlots] = useState([]);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);



  useEffect(() => {
    if (isBookingApi) {
      dispatch(BookingCategoryOptions({ option: { valueField: "id", labelField: "name" }, uid: isBookingApi.uid, salon_id: isBookingApi.salon.id }));
    }
  }, [dispatch, isBookingApi]);
  // const highlightedDates = datesData
  //   .filter(dateObj => dateObj.date_highlight)
  //   .map(dateObj => new Date(dateObj.date));
  const highlightedDates = datesData
    .filter(dateObj => dateObj.date_highlight)
    .map(dateObj => moment(dateObj.date).toDate());
  useEffect(() => {
    if (selectedCategory && objectDataServiceOnCategoryId.length > 0) {
      setLoadingTreatments(true); // Start loading
      const categoryServices = objectDataServiceOnCategoryId.filter(service =>
        service.category_id === selectedCategory
      );
      setCurrentTreatments(categoryServices.map(service => ({
        id: service.id,
        name: service.name,
        description: service.description
      })));
      if (categoryServices.length > 0) {
        setSelectedService(categoryServices[0].id);
      }
      setLoadingTreatments(false);
    }
  }, [selectedCategory, objectDataServiceOnCategoryId]);


  const toggleTreatment = async (treatmentId, e) => {
    e.stopPropagation();

    // Close all other expanded treatments except the one being toggled
    setExpandedTreatments(prev => {
      const newState = {};
      // Set all treatments to false (collapsed)
      Object.keys(prev).forEach(key => {
        newState[key] = false;
      });
      // Toggle only the clicked treatment
      newState[treatmentId] = !prev[treatmentId];
      return newState;
    });

    // Only fetch staff data if we're expanding and haven't loaded it yet
    if (!staffData[treatmentId]) {
      setStaffApiLoading(prev => ({ ...prev, [treatmentId]: true }));

      try {
        const response = await dispatch(BookingStaffOptions({
          uid: isBookingApi?.uid,
          salon_id: isBookingApi?.salon?.id,
          service_id: treatmentId
        })).unwrap();

        if (response) {
          setStaffData(prev => ({
            ...prev,
            [treatmentId]: response.map(staff => ({
              id: staff.id,
              name: `${staff.first_name} ${staff.last_name}`,
              first_name: staff.first_name,
              last_name: staff.last_name,
              profile_photo_url: staff.profile_photo_url,
              price: staff.staffservicesprice?.price || "0.00"
            }))
          }));
        }
      } catch (error) {

      } finally {
        setStaffApiLoading(prev => ({ ...prev, [treatmentId]: false }));
      }
    }
  };
  // const handleTreatmentSelection = async (treatmentId, e, categoryId) => {
  //   e.stopPropagation();
  //   // Get current selection state
  //   const currentSelection = selectedTreatments[treatmentId]?.isSelected || false;
  //   // Toggle selection with category ID
  //   const updatedTreatments = {
  //     ...selectedTreatments,
  //     [treatmentId]: {
  //       isSelected: !currentSelection,
  //       categoryId: categoryId
  //     }
  //   };

  //   // If we're unchecking, remove the treatment completely
  //   if (currentSelection) {
  //     delete updatedTreatments[treatmentId];

  //     // Clear staff selection when unchecking
  //     const updatedStaff = { ...selectedStaff };
  //     delete updatedStaff[treatmentId];
  //     setSelectedStaff(updatedStaff);
  //     setAllSelectedStaff(prev => ({
  //       ...prev,
  //       [selectedService]: updatedStaff
  //     }));

  //     // Update service summary to remove the treatment
  //     updateServiceSummary(treatmentId, false, null, categoryId);
  //   } else {
  //     // When checking, fetch staff data if not already loaded
  //     if (!staffData[treatmentId]) {
  //       try {
  //         const response = await dispatch(BookingStaffOptions({
  //           uid: isBookingApi?.uid,
  //           salon_id: isBookingApi?.salon?.id,
  //           service_id: treatmentId
  //         })).unwrap();

  //         if (response) {
  //           const staffMembers = response.map(staff => ({
  //             id: staff.id,
  //             name: `${staff.first_name} ${staff.last_name}`,
  //             first_name: staff.first_name,
  //             last_name: staff.last_name,
  //             profile_photo_url: staff.profile_photo_url,
  //             price: staff.staffservicesprice?.price || "0.00"
  //           }));

  //           setStaffData(prev => ({
  //             ...prev,
  //             [treatmentId]: staffMembers
  //           }));

  //           // Automatically select the staff if there's only one
  //           if (staffMembers.length === 1) {
  //             const staffId = staffMembers[0].id;
  //             const updatedStaff = {
  //               ...selectedStaff,
  //               [treatmentId]: staffId
  //             };
  //             setSelectedStaff(updatedStaff);
  //             setAllSelectedStaff(prev => ({
  //               ...prev,
  //               [selectedService]: updatedStaff
  //             }));

  //             // Update service summary with the selected staff's price
  //             const price = parseFloat(staffMembers[0].price);
  //             updateServiceSummary(treatmentId, true, staffId, categoryId, price);

  //             // Automatically expand the treatment details
  //             setExpandedTreatments(prev => ({
  //               ...prev,
  //               [treatmentId]: true
  //             }));
  //           } else {
  //             // Set initial staff selection to null (No Preference) for multiple staff
  //             const updatedStaff = {
  //               ...selectedStaff,
  //               [treatmentId]: null
  //             };
  //             setSelectedStaff(updatedStaff);
  //             setAllSelectedStaff(prev => ({
  //               ...prev,
  //               [selectedService]: updatedStaff
  //             }));

  //             // Update service summary with the first staff's price for No Preference
  //             const defaultPrice = staffMembers[0]?.price ? parseFloat(staffMembers[0].price) : 0;
  //             updateServiceSummary(treatmentId, true, null, categoryId, defaultPrice);
  //           }
  //         }
  //       } catch (error) {
  //         customToast.error("Error fetching staff data");
  //       }
  //     } else {
  //       // If staff data is already loaded, check if there's only one staff member
  //       const existingStaffMembers = staffData[treatmentId];
  //       if (existingStaffMembers.length === 1) {
  //         const staffId = existingStaffMembers[0].id;
  //         const price = parseFloat(existingStaffMembers[0].price);

  //         // Automatically select the only staff member
  //         const updatedStaff = {
  //           ...selectedStaff,
  //           [treatmentId]: staffId
  //         };
  //         setSelectedStaff(updatedStaff);
  //         setAllSelectedStaff(prev => ({
  //           ...prev,
  //           [selectedService]: updatedStaff
  //         }));

  //         // Update service summary with the staff's price
  //         updateServiceSummary(treatmentId, true, staffId, categoryId, price);

  //         // Automatically expand the treatment details
  //         setExpandedTreatments(prev => ({
  //           ...prev,
  //           [treatmentId]: true
  //         }));
  //       } else {
  //         // For multiple staff, set to No Preference
  //         const updatedStaff = {
  //           ...selectedStaff,
  //           [treatmentId]: null
  //         };
  //         setSelectedStaff(updatedStaff);
  //         setAllSelectedStaff(prev => ({
  //           ...prev,
  //           [selectedService]: updatedStaff
  //         }));

  //         // Update service summary with the first staff's price for No Preference
  //         const defaultPrice = existingStaffMembers[0]?.price
  //           ? parseFloat(existingStaffMembers[0].price)
  //           : 0;
  //         updateServiceSummary(treatmentId, true, null, categoryId, defaultPrice);
  //       }
  //     }
  //   }

  //   setSelectedTreatments(updatedTreatments);
  //   setAllSelectedTreatments(prev => ({
  //     ...prev,
  //     [selectedService]: updatedTreatments
  //   }));
  // };

  // Update handleStaffSelection to ensure summary is updated when staff is selected
  const handleTreatmentSelection = async (treatmentId, e, categoryId) => {
    e.stopPropagation();
    const currentSelection = selectedTreatments[treatmentId]?.isSelected || false;
    const updatedTreatments = {
      ...selectedTreatments,
      [treatmentId]: {
        isSelected: !currentSelection,
        categoryId: categoryId
      }
    };

    if (currentSelection) {
      // Unselection logic remains the same
      delete updatedTreatments[treatmentId];
      const updatedStaff = { ...selectedStaff };
      delete updatedStaff[treatmentId];
      setSelectedStaff(updatedStaff);
      setAllSelectedStaff(prev => ({
        ...prev,
        [selectedService]: updatedStaff
      }));
      updateServiceSummary(treatmentId, false, null, categoryId);
    } else {
      try {
        if (!staffData[treatmentId]) {
          const response = await dispatch(BookingStaffOptions({
            uid: isBookingApi?.uid,
            salon_id: isBookingApi?.salon?.id,
            service_id: treatmentId
          })).unwrap();

          if (response) {
            const staffMembers = response.map(staff => ({
              id: staff.id,
              name: `${staff.first_name} ${staff.last_name}`,
              first_name: staff.first_name,
              last_name: staff.last_name,
              profile_photo_url: staff.profile_photo_url,
              price: staff.staffservicesprice?.price || "0.00"
            }));

            setStaffData(prev => ({
              ...prev,
              [treatmentId]: staffMembers
            }));

            if (staffMembers.length === 1) {
              // Single staff member - automatically select them
              const singleStaff = staffMembers[0];
              const updatedStaff = {
                ...selectedStaff,
                [treatmentId]: singleStaff.id
              };
              setSelectedStaff(updatedStaff);
              setAllSelectedStaff(prev => ({
                ...prev,
                [selectedService]: updatedStaff
              }));

              updateServiceSummary(
                treatmentId,
                true,
                singleStaff.id,
                categoryId,
                parseFloat(singleStaff.price),
                singleStaff.name
              );
            } else {
              // Multiple staff members - default to "No Preference"
              const updatedStaff = {
                ...selectedStaff,
                [treatmentId]: null // null indicates "No Preference"
              };
              setSelectedStaff(updatedStaff);
              setAllSelectedStaff(prev => ({
                ...prev,
                [selectedService]: updatedStaff
              }));

              // Use the lowest price among all staff members for "No Preference"
              const lowestPrice = Math.min(...staffMembers.map(staff => parseFloat(staff.price)));
              updateServiceSummary(
                treatmentId,
                true,
                null,
                categoryId,
                lowestPrice,
                'No Preference'
              );
            }
          }
        } else {
          // Using existing staff data
          const existingStaffMembers = staffData[treatmentId];
          if (existingStaffMembers.length === 1) {
            // Single staff member logic
            const singleStaff = existingStaffMembers[0];
            const updatedStaff = {
              ...selectedStaff,
              [treatmentId]: singleStaff.id
            };
            setSelectedStaff(updatedStaff);
            setAllSelectedStaff(prev => ({
              ...prev,
              [selectedService]: updatedStaff
            }));

            updateServiceSummary(
              treatmentId,
              true,
              singleStaff.id,
              categoryId,
              parseFloat(singleStaff.price),
              singleStaff.name
            );
          } else {
            // Multiple staff members - default to "No Preference"
            const updatedStaff = {
              ...selectedStaff,
              [treatmentId]: null
            };
            setSelectedStaff(updatedStaff);
            setAllSelectedStaff(prev => ({
              ...prev,
              [selectedService]: updatedStaff
            }));

            const lowestPrice = Math.min(...existingStaffMembers.map(staff => parseFloat(staff.price)));
            updateServiceSummary(
              treatmentId,
              true,
              null,
              categoryId,
              lowestPrice,
              'No Preference'
            );
          }
        }
      } catch (error) {
        customToast.error("Error fetching staff data");
      }
    }

    setSelectedTreatments(updatedTreatments);
    setAllSelectedTreatments(prev => ({
      ...prev,
      [selectedService]: updatedTreatments
    }));
  };



  const handleStaffSelection = (treatmentId, staffId) => {
    // Find the treatment and its category
    const treatment = currentTreatments.find(t => t.id === treatmentId);
    const categoryId = treatment?.category || selectedCategory;

    // First ensure the category is selected
    setSelectedCategories(prev => {
      const newSet = new Set(prev);
      newSet.add(categoryId);
      return newSet;
    });

    // Set the selected category
    setSelectedCategory(categoryId);

    // Then ensure the treatment is selected
    if (!selectedTreatments[treatmentId]?.isSelected) {
      const updatedTreatments = {
        ...selectedTreatments,
        [treatmentId]: {
          isSelected: true,
          categoryId: categoryId
        }
      };
      setSelectedTreatments(updatedTreatments);
      setAllSelectedTreatments(prev => ({
        ...prev,
        [selectedService]: updatedTreatments
      }));
    }

    // Update staff selection
    const updatedStaff = {
      ...selectedStaff,
      [treatmentId]: staffId
    };
    setSelectedStaff(updatedStaff);
    setAllSelectedStaff(prev => ({
      ...prev,
      [selectedService]: updatedStaff
    }));

    // Clear any existing time slot for this treatment
    setSelectedTimeSlot(null);

    // Get the appropriate price and staff info
    let price = 0;
    let selectedStaffMember = null;

    if (staffId === null) {
      // For No Preference, use the first staff's price
      const firstStaffMember = staffData[treatmentId]?.[0];
      price = firstStaffMember ? parseFloat(firstStaffMember.price) : 0;
    } else {
      // For specific staff selection
      selectedStaffMember = staffData[treatmentId]?.find(staff => staff.id === staffId);
      price = selectedStaffMember ? parseFloat(selectedStaffMember.price) : 0;
    }

    // Update service summary with the selected staff's price and name
    updateServiceSummary(treatmentId, true, staffId, categoryId, price);
  };
  // const updateServiceSummary = (treatmentId, isSelected, staffId, categoryId, price = null) => {
  //   setServiceSummary(prev => {
  //     let updatedItems = [...prev.selectedItems];

  //     if (!isSelected) {
  //       updatedItems = updatedItems.filter(item => item.treatmentId !== treatmentId);
  //     } else {
  //       const existingItemIndex = updatedItems.findIndex(item => item.treatmentId === treatmentId);
  //       const treatmentService = objectDataServiceOnCategoryId.find(s => s.id === treatmentId) ||
  //         (singleSelectedServiceData?.service_id === treatmentId ? singleSelectedServiceData.serviceObjData : null);

  //       if (treatmentService) {
  //         // Get correct staff information
  //         let staffName = 'No Preference';
  //         let staffPrice = price;

  //         if (staffId) {
  //           // Check if it's from pre-selected service
  //           if (treatmentId === singleSelectedServiceData?.service_id &&
  //             staffId === singleSelectedServiceData?.staff_id) {
  //             const preSelectedStaff = singleSelectedServiceData.staffObjData;
  //             staffName = `${preSelectedStaff.first_name} ${preSelectedStaff.last_name}`;
  //             staffPrice = parseFloat(preSelectedStaff.staffservicesprice?.price || price);
  //           } else {
  //             // Get staff from staffData
  //             const selectedStaffMember = staffData[treatmentId]?.find(s => s.id === staffId);
  //             if (selectedStaffMember) {
  //               staffName = selectedStaffMember.name;
  //               staffPrice = parseFloat(selectedStaffMember.price);
  //             }
  //           }
  //         }

  //         const updatedItem = {
  //           treatmentId,
  //           treatmentName: treatmentService.name,
  //           categoryId: categoryId,
  //           staffId,
  //           staffName: staffName, // Using correct staff name
  //           price: staffPrice || 0,
  //           deposit_booked_online: treatmentService.deposit_booked_online || 0,
  //           deposit_booked_price: treatmentService.deposit_booked_price || "0.00",
  //           service_booked_online: treatmentService.service_booked_online || 1,
  //           padding_time: treatmentService.padding_time || 0,
  //           description: treatmentService.description || '',
  //           duration: treatmentService.duration || 0,
  //         };

  //         if (existingItemIndex >= 0) {
  //           updatedItems[existingItemIndex] = updatedItem;
  //         } else {
  //           updatedItems.push(updatedItem);
  //         }
  //       }
  //     }

  //     const subtotal = updatedItems.reduce((sum, item) => sum + item.price, 0);
  //     const total = subtotal;
  //     const depositTotal = updatedItems.reduce((sum, item) => {
  //       return sum + (item.deposit_booked_online === 1 ? parseFloat(item.deposit_booked_price) : 0);
  //     }, 0);

  //     return {
  //       selectedItems: updatedItems,
  //       totals: {
  //         subtotal,
  //         total,
  //         depositTotal: depositTotal || 0
  //       }
  //     };
  //   });
  // };
  const updateServiceSummary = (treatmentId, isSelected, staffId, categoryId, price = null, staffName = null) => {
    setServiceSummary(prev => {
      let updatedItems = [...prev.selectedItems];

      if (!isSelected) {
        updatedItems = updatedItems.filter(item => item.treatmentId !== treatmentId);
      } else {
        const existingItemIndex = updatedItems.findIndex(item => item.treatmentId === treatmentId);
        const treatmentService = objectDataServiceOnCategoryId.find(s => s.id === treatmentId) ||
          (singleSelectedServiceData?.service_id === treatmentId ? singleSelectedServiceData.serviceObjData : null);

        if (treatmentService) {
          // Use provided staff name or determine it based on staffId
          let finalStaffName = staffName;
          if (!finalStaffName && staffId) {
            const selectedStaffMember = staffData[treatmentId]?.find(s => s.id === staffId);
            finalStaffName = selectedStaffMember ? selectedStaffMember.name : 'No Preference';
          }

          const updatedItem = {
            treatmentId,
            treatmentName: treatmentService.name,
            categoryId: categoryId,
            staffId,
            staffName: finalStaffName || 'No Preference',
            price: price || 0,
            deposit_booked_online: treatmentService.deposit_booked_online || 0,
            deposit_booked_price: treatmentService.deposit_booked_price || "0.00",
            service_booked_online: treatmentService.service_booked_online || 1,
            padding_time: treatmentService.padding_time || 0,
            description: treatmentService.description || '',
            duration: treatmentService.duration || 0,
          };

          if (existingItemIndex >= 0) {
            updatedItems[existingItemIndex] = updatedItem;
          } else {
            updatedItems.push(updatedItem);
          }
        }
      }

      // Calculate totals...
      const subtotal = updatedItems.reduce((sum, item) => sum + item.price, 0);
      const total = subtotal;
      const depositTotal = updatedItems.reduce((sum, item) => {
        return sum + (item.deposit_booked_online === 1 ? parseFloat(item.deposit_booked_price) : 0);
      }, 0);

      return {
        selectedItems: updatedItems,
        totals: {
          subtotal,
          total,
          depositTotal: depositTotal || 0
        }
      };
    });
  };



  const handleDateChange = (date) => {
    setSelectedDate(date);
    setSelectedTimeSlot(null);
    // setSelectedTimeSlots({});
    if (activeSection === 'staff' && serviceSummary.selectedItems.length > 0) {
      handleContinue(date, true); // Here you are passing true for isDateChange
    }
  };
  const handleContinue = async (selectedDate, isDateChange = false) => {
    if (serviceSummary.selectedItems.length === 0) {
      customToast.error("Please select at least one treatment");
      return;
    }

    setLoading(true);

    try {
      // Group all selected treatments by category (including pre-selected ones)
      const treatmentsByCategory = serviceSummary.selectedItems.reduce((acc, item) => {
        // Find the service data either from allServiceBycategory or singleSelectedServiceData
        let serviceData = null;
        if (item.treatmentId === singleSelectedServiceData?.service_id) {
          serviceData = singleSelectedServiceData.serviceObjData;
        } else {
          const categoryServices = Object.values(allServiceBycategory).find(
            category => category.treatments?.some(t => t.id === item.treatmentId)
          );
          serviceData = categoryServices?.treatments?.find(t => t.id === item.treatmentId);
        }

        const categoryId = serviceData?.category_id || item.categoryId;
        const key = categoryId || 'uncategorized';

        if (!acc[key]) {
          acc[key] = [];
        }

        // Get staff data either from staffData or singleSelectedServiceData
        let staffMember = null;
        if (item.staffId) {
          if (item.treatmentId === singleSelectedServiceData?.service_id) {
            staffMember = singleSelectedServiceData.staffObjData;
          } else {
            staffMember = staffData[item.treatmentId]?.find(s => s.id === item.staffId);
          }
        }

        acc[key].push({
          treatmentId: item.treatmentId,
          treatmentName: item.treatmentName,
          staffId: item.staffId,
          price: item.price.toString(),
          service: serviceData,
          categoryId: categoryId,
          staffData: staffMember
        });

        return acc;
      }, {});

      // New code to maintain the order of categories as they appear in the summary
      const orderedCategories = [...new Set(serviceSummary.selectedItems.map(item => item.categoryId))];

      const categoriesData = orderedCategories.map(categoryId => {
        const treatments = treatmentsByCategory[categoryId] || [];
        const category = categories.find(c => c.value === categoryId);

        return {
          category_id: categoryId,
          category_name: category?.label || 'Unknown Category',
          treatments: treatments.map((item) => {
            const service = item.service;
            const staffMember = item.staffData;

            return {
              treatment_id: item.treatmentId,
              treatment_name: item.treatmentName,
              staff_id: item.staffId || null,
              staff_name: staffMember
                ? `${staffMember.first_name} ${staffMember.last_name}`
                : 'Any available staff',
              price: item.price,
              duration: service?.duration || "60",
              padding_time: service?.padding_time || "15",
              category_id: item.categoryId,
              description: service?.description || '',
            };
          })
        };
      });

      // Find the first treatment for availability check
      const firstCategory = categoriesData[0];
      const firstTreatment = firstCategory.treatments[0];

      if (!firstTreatment) {
        throw new Error("No valid treatment found");
      }

      // Prepare the availability check payload
      const availabilityPayload = {
        id: firstTreatment.treatment_id,
        category_id: firstTreatment.category_id,
        service_id: firstTreatment.treatment_id,
        staff_id: firstTreatment.staff_id || null,
        serviceObjData: {
          id: firstTreatment.treatment_id,
          position: 0,
          salon_id: isBookingApi?.salon?.id,
          category_id: firstTreatment.category_id,
          resource_id: null,
          tax_id: null,
          name: firstTreatment.treatment_name,
          description: firstTreatment.description,
          duration: firstTreatment.duration,
          padding_time: firstTreatment.padding_time,
          color: "",
          service_booked_online: 1,
          deposit_booked_online: 0,
          deposit_booked_price: "0.00",
          hide_service_booking_widget: 0,
          voucher_online: 1,
          isNotId: 0,
          add_on_services_count: 0,
          serviceprice: []
        },
        staffObjData: null,
        datetime: "",
        totalprice: serviceSummary.totals.total.toString(),
        duration: MinutesToHours(parseInt(firstTreatment.duration)) || "01:00",
        padding_time: MinutesToHours(parseInt(firstTreatment.padding_time)) || "00:15",
        durationWithPadding: firstTreatment.padding_time
          ? MinutesToHours(parseInt(firstTreatment.padding_time) + parseInt(firstTreatment.duration))
          : MinutesToHours(parseInt(firstTreatment.duration) || 0),
        parentAppointmentEndTime: "",
        resource_item_id: "",
        resource_name: "",
        appointment_id: "",
        busytime_id: "",
        dateof: moment(selectedDate).format("YYYY-MM-DD HH:mm:00"),
        start_datetime: moment(selectedDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        listview: "Appointment",
        salon_id: isBookingApi?.salon?.id,
        uid: isBookingApi?.uid,
        page_type: "BookingLink",
        formType: "bookingwidget/staff/view",
        categories: categoriesData
      };

      // Check staff availability
      const availabilityResponse = await dispatch(checkStaffAvailabilityApi(availabilityPayload)).unwrap();
      if (availabilityResponse?.available_slots.length === 0) {
        customToast.error(availabilityResponse?.message);
      }
      if (availabilityResponse) {
        // if (!selectedTimeSlot && activeSection === 'staff' && !isDateChange) {
        //   customToast.error(" Please select a time slot to book the service.");
        //   return;
        // }
        if (!selectedTimeSlot && activeSection === 'staff' && !isDateChange && !(availabilityResponse?.available_slots.length === 0)) {
          customToast.error(" Please select a time slot to book the service.");
          return;
        }
        // Handle time slot selection
        if (activeSection === 'staff' && selectedTimeSlot && !isDateChange) {
          // Calculate total duration including padding time for all selected services
          const totalDuration = serviceSummary.selectedItems.reduce((total, item) => {
            return total + (parseInt(item.duration) + parseInt(item.padding_time));
          }, 0);

          // Create start and end times using moment
          const startTime = moment(`${selectedTimeSlot.date} ${selectedTimeSlot.time}`);
          const endTime = startTime.clone().add(totalDuration, 'minutes');

          // Prepare services array for booking summary
          const services = serviceSummary.selectedItems.map(item => ({
            service_id: item.treatmentId,
            staff_id: item.staffId || "",
            start_time: startTime.format('HH:mm'),
            end_time: moment(startTime)
              .add(parseInt(item.duration) + parseInt(item.padding_time), 'minutes')
              .format('HH:mm')
          }));

          // Call booking summary API with correct timing
          const bookingSummaryPayload = {
            services,
            date: selectedTimeSlot.date,
            start_time: startTime.format('HH:mm'),
            end_time: endTime.format('HH:mm'),
            salon_id: isBookingApi?.salon?.id,
            uid: isBookingApi?.uid,
            // selected_staff: availableSlotSelectedStaff?.selected_staff,
            all_staff: availableSlotSelectedStaff?.all_staff,
            // resource_ids: availableSlotSelectedStaff?.resource_ids

          };

          try {
            const bookingSummaryResponse = await dispatch(getBookingSummaryApi(bookingSummaryPayload)).unwrap();

            if (bookingSummaryResponse) {
              // Update service summary with correct timing
              const updatedServiceSummary = {
                ...serviceSummary,
                selectedItems: serviceSummary.selectedItems.map((item, index) => {
                  const itemStartTime = moment(startTime)
                    .add(
                      index > 0
                        ? serviceSummary.selectedItems
                          .slice(0, index)
                          .reduce((total, prevItem) =>
                            total + (parseInt(prevItem.duration) + parseInt(prevItem.padding_time)), 0)
                        : 0,
                      'minutes'
                    );

                  const itemEndTime = itemStartTime
                    .clone()
                    .add(parseInt(item.duration) + parseInt(item.padding_time), 'minutes');

                  return {
                    ...item,
                    selectedTime: itemStartTime.format('HH:mm:ss'),
                    selectedDate: selectedTimeSlot.date,
                    endTime: itemEndTime.format('HH:mm:ss')
                  };
                })
              };

              // Dispatch updated data
              dispatch(BookingSelectedServicesData({
                categories: categoriesData.map(category => ({
                  ...category,
                  treatments: category.treatments.map((treatment, index) => ({
                    ...treatment,
                    selectedTime: services[index].start_time,
                    selectedDate: selectedTimeSlot.date,
                    endTime: services[index].end_time,
                    formattedDateTime: `${selectedTimeSlot.date} ${services[index].start_time}`
                  }))
                })),
                totals: serviceSummary.totals,
                selectedDate: selectedTimeSlot.date,
                bookingSummary: bookingSummaryResponse
              }));

              setServiceSummary(updatedServiceSummary);
              setActiveSection('payment-services');

            } else {
              customToast.error("Failed to get booking summary. Please try again.");
            }
          } catch (error) {
            customToast.error("Error getting booking summary: " + (error.message || "Please try again"));
          }
        } else {
          setAvailableTimeSlots(availabilityResponse?.available_slots || []);
          setVoucherFieldVisible(availabilityResponse.voucher_availability);
          setActiveSection('staff');
        }
      } else {
        customToast.error("Selected staff is not available. Please choose another time slot.");
      }
    } catch (error) {
      customToast.error("Error checking staff availability: " + (error.message || "Please try again"));
    } finally {
      setLoading(false);
    }
  };

  const handleApiError = (action) => {
    const status = action.payload?.status;
    const errors = action.payload?.message?.errors;
    const message = action.payload?.message?.message;

    if (status === 422) {
      const NotifyContent = () => (
        <>
          <p className="mb-2 text-light text-justify">{message}</p>
          <ul className="list-unstyled">
            {errors && Object.entries(errors).map(([key, messages], i) =>
              messages.map((msg, j) => (
                <li key={`${i}-${j}`} className="text-light form-text text-start">
                  {msg}
                </li>
              ))
            )}
          </ul>
        </>
      );
      customToast.error(<NotifyContent />);
    } else if (status === 410) {
      customToast.error("Failed to update");
    }
  };
  useEffect(() => {
    if (activeSection === 'staff' && serviceSummary.selectedItems.length > 0) {
      const month = selectedDate.getMonth() + 1; // JavaScript months are 0-indexed, add 1 for human-readable format
      const year = selectedDate.getFullYear();
      fetchStaffAvailabilityCalendar(month, year);
    }
  }, [activeSection, selectedDate, serviceSummary.selectedItems.length === 0]); // W
  const fetchStaffAvailabilityCalendar = async (month, year) => {
    // setIsCalendarLoading(true);
    try {
      const response = await axios.post(
        `${config.API_URL}widget/booking/staff-availability-calendar`,
        {
          salon_id: isBookingApi?.salon?.id, // Use dynamic salon ID from your booking data
          month,
          year,
          services: serviceSummary.selectedItems.map(item => ({
            service_id: item.treatmentId,
            staff_id: item.staffId || ""
          }))
        },
        {
          headers: authHeader()
        }
      );

      if (response.data && response.data) {
        setDatesData(response.data?.data);
      }
    }
    catch (error) {
      customToast.error(error?.response?.data?.errors);
    } finally {
      // setIsCalendarLoading(false);
    }
  };

  const handleCategoryClick = async (category) => {
    setServicesLoading(true);

    try {
      // Toggle category selection
      setSelectedCategories(prev => {
        const newSet = new Set(prev);
        if (newSet.has(category.value)) {
          newSet.delete(category.value);
        } else {
          newSet.add(category.value);
        }
        return newSet;
      });

      setSelectedCategory(category.value);
      setTreatmentApiLoading(true);

      const response = await dispatch(BookingServiceOptions({
        uid: isBookingApi?.uid,
        salon_id: isBookingApi?.salon?.id,
        category_id: category.value
      })).unwrap();

      if (response) {
        // Clear current treatments before setting new ones
        setCurrentTreatments([]);

        // Map new treatments
        const newTreatments = response.map(service => ({
          id: service.id,
          name: service.name,
          description: service.description,
          category: category.value,
          duration: service.duration,
          padding_time: service.padding_time
        }));

        // Update current treatments with only the new category's treatments
        setCurrentTreatments(newTreatments);

        // Update other states as before
        setCategoryTreatments(prev => ({
          ...prev,
          [category.value]: response
        }));

        setSelectedCategoryData(prev => ({
          ...prev,
          [category.value]: {
            id: category.value,
            name: category.label,
            treatments: response
          }
        }));

        setAllServiceByCategory(prev => ({
          ...prev,
          [category.value]: {
            id: category.value,
            name: category.label,
            treatments: response
          }
        }));
      }
    } catch (error) {
      customToast.error("Error loading treatments");
    } finally {
      setTreatmentApiLoading(false);
      setServicesLoading(false);
    }
  };
  useEffect(() => {
    if (isServiceOption) {
      setServiceApiLoading(false); // End loading when data is received
    }
  }, [isServiceOption]);

  useEffect(() => {
    if (categories && categories.length > 0 && !selectedCategory) {
      setServicesLoading(true);
      const firstCategory = categories[0];

      if (firstCategory?.value) {
        setSelectedCategory(firstCategory?.value);
        handleCategoryClick(firstCategory)
          .finally(() => {
            setServicesLoading(false);
          });
      } else {
        setServicesLoading(false);
      }
    }
  }, [categories]);

  // Add this effect to preserve selections when switching categories
  useEffect(() => {
    if (selectedCategory && objectDataServiceOnCategoryId.length > 0) {
      setLoadingTreatments(true);
      const categoryServices = objectDataServiceOnCategoryId.filter(
        service => service.category_id === selectedCategory
      );

      // Preserve existing treatments while adding new ones
      setCurrentTreatments(prev => {
        const existingTreatments = prev.filter(t =>
          !categoryServices.some(cs => cs.id === t.id)
        );
        const newTreatments = categoryServices.map(service => ({
          id: service.id,
          name: service.name,
          description: service.description,
          category: service.category_id
        }));
        return [...existingTreatments, ...newTreatments];
      });

      if (categoryServices.length > 0) {
        setSelectedService(categoryServices[0].id);
      }
      setLoadingTreatments(false);
    }
  }, [selectedCategory, objectDataServiceOnCategoryId]);

  // Add this effect to load treatments for all selected categories
  useEffect(() => {
    selectedCategories.forEach(categoryId => {
      if (!categoryTreatments[categoryId]) {
        dispatch(BookingServiceOptions({
          uid: isBookingApi?.uid,
          salon_id: isBookingApi?.salon?.id,
          category_id: categoryId
        }));
      }
    });
  }, [selectedCategories]);



  const override = css`
  display:block;
  `;

  // Add custom date picker styling
  const CustomDateInput = forwardRef(({ value, onClick }, ref) => (
    <button className="custom-date-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  CustomDateInput.displayName = 'CustomDateInput';
  useEffect(() => {
    if (singleSelectedServiceData?.category_id && activeTab === 'services') {
      setServicesLoading(true); // Start loading

      const categoryId = singleSelectedServiceData.category_id;
      const serviceId = singleSelectedServiceData.service_id;
      const staffId = singleSelectedServiceData.staff_id;
      const serviceData = singleSelectedServiceData.serviceObjData;
      const staffData = singleSelectedServiceData.staffObjData;

      // Pre-select the category
      setSelectedCategory(categoryId);
      setSelectedCategories(prev => {
        const newSet = new Set(prev);
        newSet.add(categoryId);
        return newSet;
      });

      // Fetch treatments for the category
      dispatch(BookingServiceOptions({
        uid: isBookingApi?.uid,
        salon_id: isBookingApi?.salon?.id,
        category_id: categoryId
      })).then(response => {
        if (response.payload) {
          // Update states with response data
          const treatments = response.payload.map(service => ({
            id: service.id,
            name: service.name,
            description: service.description,
            category: categoryId,
            duration: service.duration,
            padding_time: service.padding_time
          }));

          setCurrentTreatments(treatments);
          setCategoryTreatments(prev => ({
            ...prev,
            [categoryId]: response.payload
          }));

          setSelectedCategoryData(prev => ({
            ...prev,
            [categoryId]: {
              id: categoryId,
              name: categories.find(cat => cat.value === categoryId)?.label || '',
              treatments: response.payload
            }
          }));

          setAllServiceByCategory(prev => ({
            ...prev,
            [categoryId]: {
              id: categoryId,
              name: categories.find(cat => cat.value === categoryId)?.label || '',
              treatments: response.payload
            }
          }));
          setSelectedTreatments(prev => ({
            ...prev,
            [serviceId]: {
              isSelected: true,
              categoryId: categoryId
            }
          }));
          // Fetch all staff for the service
          dispatch(BookingStaffOptions({
            uid: isBookingApi?.uid,
            salon_id: isBookingApi?.salon?.id,
            service_id: serviceId
          })).then(response => {
            if (response.payload) {
              // Map all staff including the pre-selected one
              const allStaffMembers = response.payload.map(staff => ({
                id: staff.id,
                name: `${staff.first_name} ${staff.last_name}`,
                first_name: staff.first_name,
                last_name: staff.last_name,
                profile_photo_url: staff.profile_photo_url,
                price: staff.staffservicesprice?.price || "0.00"
              }));

              // Update staffData with all staff members
              setStaffData(prev => ({
                ...prev,
                [serviceId]: allStaffMembers
              }));
            }
          });
          setSelectedStaff(prev => ({
            ...prev,
            [serviceId]: staffId
          }));

          // Update service summary
          const price = parseFloat(staffData?.staffservicesprice?.price || "0.00");
          updateServiceSummary(serviceId, true, staffId, categoryId, price);

          setExpandedTreatments(prev => ({
            ...prev,
            [serviceId]: true
          }));
        }
      }).finally(() => {
        setServicesLoading(false); // End loading
      });
    }
  }, [singleSelectedServiceData, categories, dispatch, isBookingApi?.uid, isBookingApi?.salon?.id, activeTab]);

  // Add this helper function near the top of your component
  const isCategoryHasTreatments = (categoryId) => {
    return serviceSummary.selectedItems.some(item => item.categoryId === categoryId);
  };

  // Update the helper function
  const isCategoryActive = (categoryId) => {
    return categoryId === selectedCategory || serviceSummary.selectedItems.some(item => item.categoryId === categoryId);
  };

  return (
    <>
      {loading && <LoadingOverlay />}

      {!loading && hide === "main-content" && (
        <><>
          <div className="heading-container">
            <h1 className="booking-heading">
              {isBookingApi.salon.business_name}  <span className="bold-text"> {isBookingApi.salon.business_address}</span>
            </h1>

          </div>
          {activeSection !== "payment-services" && activeTab !== 'vouchers' && activeTab !== 'packages' &&
            <div className="please-sele">
              <a
                role="button"
                onClick={() => {
                  // setHide("home");
                  if (isBookingSelectedServicesData?.length === 1) {
                    dispatch(BookingSelectedServicesData());
                    dispatch(PreviewStep(isBookingStep));
                  } else {
                    dispatch(BookingRemoveServicesData(singleSelectedServiceData));
                    dispatch(PreviewStep(isBookingStep));
                  }
                }}
              >
                <img src={config.imagepath + "left-arrow.svg"} alt="" className="me-3" width="21" />
                {t("Please select category")}
              </a>
            </div>}
        </>
          <div className="booking-step-2">
            <div className={activeSection !== "payment-services" && activeTab !== 'vouchers' && activeTab !== 'packages' && activeTab !== 'subscriptions' && "sidebar"}>
              {activeSection === 'staff' && activeSection !== "payment-services" &&
                activeTab !== 'vouchers' && activeTab !== 'packages' && activeTab !== 'subscriptions' && (
                  <div className="calendar-container">
                    {loading && (
                      <div className="calendar-loading-overlay">
                        <MoonLoader size={40} color={'#8c1c4d'} />
                      </div>
                    )}
                    <DatePicker
                      selected={selectedDate}
                      onChange={handleDateChange}
                      inline
                      highlightDates={highlightedDates}
                      minDate={new Date()}
                      excludeDates={datesData
                        .filter(dateObj => !dateObj.date_highlight)
                        .map(dateObj => moment(dateObj.date).toDate())
                      }
                      onMonthChange={(date) => {
                        const month = date.getMonth() + 1;
                        const year = date.getFullYear();
                        fetchStaffAvailabilityCalendar(month, year);
                      }}
                    />
                  </div>
                )}
              <>
                {activeSection === 'services' && activeSection !== "payment-services" && activeTab !== 'vouchers' && activeTab !== 'packages' && activeTab !== 'subscriptions' && (
                  categoryApiStatus && categoryApiStatus.BookingCategoryOptions === "loading" ? (
                    <ApiStatus actionType="categoriesbookingLink" />
                  ) : (
                    <>
                      {categories.length > 0 ? (
                        categories.map((category, index) => (
                          <button
                            key={index}
                            className={`service-btn ${isCategoryActive(category.value) ? 'active' : ''}`}
                            onClick={() => handleCategoryClick(category)}
                            disabled={categoryApiLoading}
                          >
                            {category.label}
                          </button>
                        ))
                      ) : (
                        <li className="fw-bold items-option nodatafound">
                          {t("No data found")}
                        </li>
                      )}
                    </>
                  )
                )}
              </>
            </div>

            <div className="main-content">
              {activeSection !== "payment-services" &&

                <>
                  {currentTreatments.length > 0 && (
                    <div className="tabs">

                      <button className={`tab ${activeTab === 'services' ? 'active' : ''}`} onClick={() => setActiveTab('services')}>Services</button>
                      <button className={`tab ${activeTab === 'vouchers' ? 'active' : ''}`} onClick={() => setActiveTab('vouchers')}>Vouchers</button>
                      <button className={`tab ${activeTab === 'packages' ? 'active' : ''}`} onClick={() => setActiveTab('packages')}>Packages</button>
                      <button className={`tab ${activeTab === 'subscriptions' ? 'active' : ''}`} onClick={() => setActiveTab('subscriptions')}>Subscriptions</button>
                    </div>)}
                </>}

              <div className="service-sections">
                <div className="section active">
                  {activeTab === 'services' && activeSection !== "payment-services" && (
                    <div className="service-selection-header">
                      {currentTreatments.length > 0 && (
                        <>
                          <button
                            className={activeSection === 'services' ? 'active' : ''}
                            onClick={() => setActiveSection('services')}
                          >
                            Select Services
                          </button>
                          <>
                            {serviceSummary.selectedItems.length > 0 &&
                              <button
                                className={activeSection === 'staff' ? 'active' : ''}
                                onClick={() => setActiveSection('staff')}
                              >
                                Staff Availability
                              </button>}
                          </>

                        </>
                      )}
                    </div>
                  )}

                  {activeTab === 'services' && activeSection === 'services' && (
                    <div className="section-content">
                      {treatmentApiLoading || servicesLoading ? (
                        <ApiStatus actionType="serviceapibookingLink" />
                      ) : (
                        <>
                          {currentTreatments.length === 0 ? (
                            <div className="mt-3 service-not-available">
                              <p className="m-0 fw-semibold">Service not available at this time</p>
                            </div>
                          ) : (
                            currentTreatments
                              .filter(treatment => {
                                // Filter out treatments where hide_service_booking_widget is 1
                                const service = objectDataServiceOnCategoryId.find(s => s.id === treatment.id);
                                return service && service.hide_service_booking_widget !== 1;
                              })
                              .map(treatment => (
                                <div key={treatment.id} className="treatment-item">
                                  <div
                                    className={`treatment-header ${selectedTreatments[treatment.id]?.isSelected ? 'active' : ''}`}
                                    onClick={(e) => toggleTreatment(treatment.id, e)}
                                  >
                                    <div className="treatment-content">
                                      <div className="d-flex justify-content-left align-items-center">
                                        <div className="user me-3">
                                          <img src={config.imagepath + "serviceicon.svg"} alt="" className="rounded-circle wh-36" />
                                        </div>
                                        <div className="treatment-info">
                                          <span className="treatment-name">{treatment.name}</span>
                                        </div>
                                      </div>
                                      <input
                                        type="checkbox"
                                        checked={selectedTreatments[treatment.id]?.isSelected || false}
                                        onChange={(e) => handleTreatmentSelection(treatment.id, e, selectedCategory)}
                                        className="treatment-checkbox"
                                      />
                                    </div>
                                  </div>

                                  {expandedTreatments[treatment.id] && (
                                    <div className="treatment-details">
                                      <p className="treatment-description">{treatment.description}</p>
                                      <div className="staff-options">
                                        {staffApiLoading[treatment.id] ? (
                                          <ApiStatus actionType="staffapibookingLink" />
                                        ) : (
                                          <>
                                            {/* Conditionally render No Preference Option */}
                                            {staffData[treatment.id]?.length > 1 && (
                                              <div
                                                className="staff-option"
                                                onClick={() => handleStaffSelection(treatment.id, null)}
                                                style={{ cursor: 'pointer' }}
                                              >
                                                <input
                                                  type="radio"
                                                  name={`staff-${treatment.id}`}
                                                  checked={selectedStaff[treatment.id] === null && selectedTreatments[treatment.id]?.isSelected}
                                                  onChange={() => { }}
                                                />
                                                <div className="d-flex justify-content-between align-items-center w-100">
                                                  <h6 className="mb-0">{t("No Preference")}</h6>
                                                  <span className="fw-semibold">
                                                    ${Math.min(...staffData[treatment.id].map(staff => parseFloat(staff.price))).toFixed(2)}
                                                  </span>
                                                </div>
                                              </div>
                                            )}

                                            {/* Staff Options */}
                                            {staffData[treatment.id]?.map(staff => (
                                              <div
                                                key={staff.id}
                                                className="staff-option"
                                                onClick={() => handleStaffSelection(treatment.id, staff.id)}
                                                style={{ cursor: 'pointer' }}
                                              >
                                                <input
                                                  type="radio"
                                                  name={`staff-${treatment.id}`}
                                                  value={staff.id}
                                                  checked={selectedStaff[treatment.id] === staff.id}
                                                  onChange={() => { }}
                                                />
                                                <div className="d-flex justify-content-between align-items-center w-100">
                                                  <h6 className="mb-0">{staff.name}</h6>
                                                  <span className="fw-semibold">${staff.price}</span>
                                                </div>
                                              </div>
                                            ))}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))
                          )}
                        </>
                      )}
                    </div>
                  )}


                  {activeTab === 'services' && activeSection === 'staff' && (
                    <div className="section-content staff-availability">
                      {/* With Preference Section */}
                      {availableTimeSlots && availableTimeSlots.length > 0 && (
                        <div className="staff-category preferred-staff">
                          <div className="staff-category-title">
                            <span className="preferred-badge">Available Time Slots</span>
                          </div>
                          <div className="staff-card preferred">
                            <div className="time-slots-row">
                              {availableTimeSlots.map((staffSlot, index) => (
                                <button
                                  key={`time-${index}`}
                                  className={`time-slot-btn ${selectedTimeSlot?.time === staffSlot.start_time ? 'selected' : ''
                                    }`}
                                  onClick={() => {
                                    setSelectedTimeSlot({
                                      time: staffSlot.start_time,
                                      endTime: staffSlot.end_time,
                                      date: moment(selectedDate).format('YYYY-MM-DD'),
                                    });
                                  }}
                                >
                                  {moment(staffSlot.start_time, 'HH:mm:ss').format('h:mm A')} -
                                  {moment(staffSlot.end_time, 'HH:mm:ss').format('h:mm A')}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}

                      {/* No Preference Section */}

                    </div>
                  )}
                  {activeTab === 'services' && activeSection === "payment-services" && (
                    <Elements stripe={stripePromise}>
                      <BookingStep3
                        voucherFieldVisible={voucherFieldVisible}
                        setActiveSection={setActiveSection}
                        paymentSummary={serviceSummary} // Pass the entire service summary
                        isBookingSelectedServicesData={isBookingSelectedServicesData || []}
                      />
                    </Elements>
                  )}

                  {activeTab === 'vouchers' && (
                    <Elements stripe={stripePromise}>
                      <VoucherStep2 isBookingStep={isBookingStep} bookingStepName={'BuyVoucher'} />
                    </Elements>
                  )}
                  {activeTab === 'packages' && (
                    // <Elements stripe={stripePromise}>
                    <MemebershipStep2 isBookingStep={isBookingStep} bookingStepName={bookingStepName} />
                    // </Elements>
                  )}
                  {activeTab === 'subscriptions' && (

                    <SubscriptionStep2 isBookingStep={isBookingStep} bookingStepName={bookingStepName} isBookingSelectedSubscriptionData={isBookingSelectedSubscriptionData} />


                  )}
                </div>
              </div>
            </div>
            {activeSection !== "payment-services" && activeTab !== 'vouchers' && activeTab !== 'packages' && activeTab !== 'subscriptions' &&


              <div className="service-summary">
                {serviceSummary.selectedItems.length === 0 ? (
                  <div className="summary-panel">
                    <div className="summary-header-container">
                      <h2 className="summary-header">Services Summary</h2>
                      <span className="service-count">0</span>
                    </div>
                    <div className="empty-summary">
                      <p className="text-muted">Add Services</p>
                    </div>
                    <div className="summary-total">
                      <span>Total: </span>
                      <span>${(0).toFixed(2)}</span>
                    </div>
                  </div>
                ) : (
                  <>
                    {/* Selected Services */}
                    <div className="summary-header-container">
                      <h2 className="summary-header">Services Summary</h2>
                      <span className="service-count">{serviceSummary.selectedItems.length}</span>
                    </div>
                    {Object.entries(
                      serviceSummary.selectedItems.reduce((acc, item) => {
                        // Find the category from either current treatments or the selected service data
                        let categoryId;
                        let categoryName;

                        if (item.treatmentId === singleSelectedServiceData?.service_id) {
                          categoryId = singleSelectedServiceData.category_id;
                          categoryName = categories.find(cat => cat.value === categoryId)?.label;
                        } else {
                          const treatment = currentTreatments.find(t => t.id === item.treatmentId);
                          categoryId = treatment?.category || item.categoryId;
                          categoryName = categories.find(cat => cat.value === categoryId)?.label;
                        }

                        // Use the actual category name or fall back to the one stored in the item
                        const finalCategoryName = categoryName || item.categoryName || 'Uncategorized';

                        if (!acc[finalCategoryName]) {
                          acc[finalCategoryName] = [];
                        }
                        acc[finalCategoryName].push(item);
                        return acc;
                      }, {})
                    ).map(([categoryName, items]) => (
                      <div key={categoryName} className="service-category">
                        <div className="service-category-title">
                          <strong>{categoryName}</strong>
                        </div>
                        {items.map((item) => (
                          <div key={item.treatmentId} className="summary-item">
                            <div className="summary-service-info">
                              <div className="summary-service-name">
                                {item.treatmentName}
                                <div className="summary-staff">with {item.staffName}</div>
                              </div>
                            </div>
                            <div className="summary-price">${item.price.toFixed(2)}</div>
                          </div>
                        ))}
                      </div>
                    ))}

                    {/* Payment Summary */}
                    <div className="summary-divider" />
                    <div className="payment-summary">
                      <h2>Payment Summary</h2>
                      <div className="summary-row">
                        <span>Item Total</span>
                        <span>${serviceSummary.totals.subtotal.toFixed(2)}</span>
                      </div>
                      {/* <div className="summary-row">
                        <span>Item Discount</span>
                        <span>-${serviceSummary.totals.discount.toFixed(2)}</span>
                      </div> */}
                      {/* <div className="summary-row">
                        <span>Taxes & Fee</span>
                        <span>${serviceSummary.totals.taxes.toFixed(2)}</span>
                      </div> */}
                      <div className="summary-row total">
                        <span>Total:</span>
                        <span>${serviceSummary.totals.total.toFixed(2)}</span>
                      </div>
                    </div>

                    {/* Continue Button */}
                    <div className="summary-actions">
                      {availabletimeApiStatus && (availabletimeApiStatus.BookingNextResourceItemTimeApi === "loading" ||
                        availabletimeApiStatus.BookingResourceAnyStaffApi === "loading") && (
                          <div className="loader-container d-flex align-items-center">
                            <div className="modal-backdrop show"></div>
                            <div className="row mx-auto custom-loader-css">
                              <div className="col-12 d-flex justify-content-center mb-5">
                                <MoonLoader css={override} size={80} color={'#8c1c4d'} loading={true} />
                              </div>
                              <div className="col-12 text-center">
                                <h4 className="color-wine">Checking available appointment times...</h4>
                              </div>

                              {/* <div className="col-12 text-center">
                            <h4 className="color-wine">{processmsg}</h4>
                          </div> */}


                            </div>
                          </div>
                        )}
                      <button
                        className="continue-btn"
                        onClick={() => {
                          setLoading(true);
                          setActiveLoading("continue");
                          handleContinue(selectedDate);
                        }}
                      >
                        Continue to Book
                        <span className="total-amount">${serviceSummary.totals.total.toFixed(2)}</span>
                      </button>
                      {/* )} */}
                    </div>
                  </>
                )}
              </div>

            }
          </div></>
      )}

    </>
  );
}
BookingStep2.propTypes = {
  isBookingStep: PropTypes.number.isRequired,
  isBookingSelectedServicesData: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    service_id: PropTypes.number,
    staff_id: PropTypes.number,
    serviceObjData: PropTypes.object,
    staffObjData: PropTypes.object,
    category_id: PropTypes.number
  })),
  singleSelectedServiceData: PropTypes.object
};
export default BookingStep2;